import { type ReactNode, type SyntheticEvent } from 'react'
import { Alert } from '@mui/material'
import Snackbar, { type SnackbarCloseReason } from '@mui/material/Snackbar'
import { SystemStyleObject, Theme } from '@mui/system'

type Props = {
  open: boolean
  wrapperStyles?: SystemStyleObject<Theme>
  sx?: SystemStyleObject<Theme>
  onClose?: (event?: SyntheticEvent | Event, reason?: SnackbarCloseReason) => void
  message: ReactNode
  severity: 'error' | 'warning' | 'info' | 'success' | undefined
  autoHideDuration?: number
  anchorOrigin?: {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'center' | 'right'
  }
}

const CustomSnackbar = ({
  open,
  onClose,
  message,
  severity = 'info' as 'info' | 'error' | 'warning' | 'success',
  autoHideDuration = 5000,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
  },
  sx: callerSx,
  wrapperStyles = {},
  ...props
}: Props) => {
  return (
    <Snackbar
      sx={{ ...wrapperStyles }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      {...props}>
      <Alert onClose={onClose} severity={severity} sx={callerSx}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default CustomSnackbar
